/** One label and its explanation lines, e.g. ["Streaks", ["A tie ends a streak."]]. */
export type CountingNote = readonly [label: string, lines: readonly string[]];

/** "How these are counted": the quiet reference list under the Hall of Fame and Milestones cards. */
export function CountingNotes({ id, notes }: { id: string; notes: readonly CountingNote[] }) {
  return (
    <section className="hof__notes" aria-labelledby={id}>
      <h3 id={id} className="feature__subhead">
        How these are counted
      </h3>
      <dl className="hof__notes-list">
        {notes.map(([label, lines]) => (
          <div key={label} className="hof__note">
            <dt>{label}</dt>
            <dd>
              {lines.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
